import { render } from "./VGpuDeviceList.vue?vue&type=template&id=cb0773f6"
import script from "./VGpuDeviceList.vue?vue&type=script&lang=js"
export * from "./VGpuDeviceList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__